import { NavLink, Outlet } from "react-router-dom";
import { LayoutDashboard, FileText, BookOpen, Plus } from "lucide-react";
import { Button } from "./ui/button";

export default function Layout() {
  return (
    <div className="rx-shell">
      <aside className="rx-sidebar p-5" data-testid="sidebar">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-9 h-9 rounded-md bg-blue-600 text-white flex items-center justify-center font-bold font-display">
            R
          </div>
          <div>
            <div className="font-display font-bold text-base leading-none">Reformas</div>
            <div className="text-xs text-slate-500 mt-1">Express</div>
          </div>
        </div>

        <NavLink
          to="/nuevo"
          data-testid="new-budget-cta"
          className="block mb-6"
        >
          <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white h-10 rounded-md gap-2">
            <Plus className="w-4 h-4" /> Nuevo presupuesto
          </Button>
        </NavLink>

        <nav className="flex flex-col gap-1">
          <NavLink to="/" end data-testid="nav-dashboard" className={({ isActive }) => `rx-nav-link ${isActive ? "active" : ""}`}>
            <LayoutDashboard className="w-4 h-4" />
            <span>Presupuestos</span>
          </NavLink>
          <NavLink to="/catalogo" data-testid="nav-catalog" className={({ isActive }) => `rx-nav-link ${isActive ? "active" : ""}`}>
            <BookOpen className="w-4 h-4" />
            <span>Catálogo de precios</span>
          </NavLink>
          <NavLink to="/nuevo" data-testid="nav-new" className={({ isActive }) => `rx-nav-link ${isActive ? "active" : ""}`}>
            <FileText className="w-4 h-4" />
            <span>Nuevo</span>
          </NavLink>
        </nav>

        <div className="mt-auto text-[11px] text-slate-400 leading-relaxed pt-6">
          <div className="font-display font-bold text-slate-700 text-xs uppercase tracking-widest mb-2">
            B2B SaaS · v1
          </div>
          Asistente IA · Claude Sonnet 4.5 · Datos mock
        </div>
      </aside>

      <main className="rx-main">
        <Outlet />
      </main>
    </div>
  );
}
